import axios from "axios";
import { history } from "../helpers";
import { Toast } from "./toast";
import { updateCommonLoader, resetState } from "redux/reducer/homeSlice";
import { store } from "redux/store/store";
import { userLogout } from "./customer";
import CryptoJS from "crypto-js";

const navigator_info = window.navigator;
const screen_info = window.screen;
let uid = navigator_info.mimeTypes.length;
uid += navigator_info.userAgent.replace(/\D+/g, '');
uid += navigator_info.plugins.length;
uid += screen_info.height + '';
uid += screen_info.width + '';
uid += screen_info.pixelDepth || '';


let agent = navigator.userAgent.match(/^[^\(]+\((\w+)/);

const token = localStorage.getItem("token");

async function getPublicIPMethod() {
  return new Promise((resolve, reject) => {
    // Simulate an asynchronous operation
    setTimeout(async () => {
      try {
        const response = await fetch('https://ipinfo.io/json');
        const data = await response.json();
        resolve(data.ip || null);
      } catch (error) {
        console.error("Failed to fetch IP:", error);
        resolve(null); // ensure app doesn't break
      }
    }, 500);
  });
}

const dataIP = await getPublicIPMethod();

const commonHeaderwithOutToken = {
  updatedFrom: "WEB",
  createdFrom: "WEB",
  deviceid: uid,
  ip: dataIP,
  userAgent: agent
};

const commonHeaderwithToken = {
  updatedFrom: "WEB",
  createdFrom: "WEB",
  deviceid: uid,
  Authorization: `Bearer ${token}`,
  ip: dataIP,
  userAgent: agent
};

// for encript and decript 
const SECRET_KEY = "|hzQ$$MRh<SnA#|";

// Function to encrypt data and return as a Base64-encoded string
const encryptData = (data) => {
  if (!data) return data;
  const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
  return btoa(ciphertext); // Convert to Base64 string for safe transmission
};

// Function to decrypt the response data
const decryptData = (encryptedText) => {
  if (!encryptedText) return encryptedText;
  const bytes = CryptoJS.AES.decrypt(atob(encryptedText), SECRET_KEY);
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};

export const axiosInstanceWithoutToken = axios.create({
  baseURL: 'your_base_url_here',
  headers: {
    common: {
      updatedFrom: "WEB",
      createdFrom: "WEB",
      deviceid: uid,
    }
  }
});

export const axiosInstance = axios.create({
  baseURL: 'your_base_url_here',
  headers: {
    common: token ? commonHeaderwithToken : commonHeaderwithOutToken,
  },
});

// axiosInstance.interceptors.request.use(
//   (config) => {

//     const token = localStorage.getItem("token");
//     store.dispatch(updateCommonLoader(true));
//     // ✅ Ensure `noAuth` is preserved by explicitly checking `config.noAuth`
//     if (!config.noAuth && token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     } else if (!token && !config.noAuth) {
//       
//       // Reject the request to prevent API call
//       return Promise.reject(new axios.Cancel("No token available"));
//     }
//     return config;
//   },
//   (error) => {
//     store.dispatch(updateCommonLoader(false));
//     return Promise.reject(error);
//   }
// );

axiosInstance.interceptors.request.use(config => {
  const token = localStorage.getItem("token");
  store.dispatch(updateCommonLoader(true));
  // if (config.data) {
  //   config.data = encryptData(config.data); // Encrypt data and send as text
  // }
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // 
  return config;
}, error => {
  store.dispatch(updateCommonLoader(false));
  return Promise.reject(error);
});

axiosInstance.interceptors.response.use(response => {
  store.dispatch(updateCommonLoader(false));
  // if (typeof response.data === "string") {
  //   response.data = decryptData(response.data); // Decrypt the response
  // }
  // 
  return response
},
  error => {
    setTimeout(() => {
      store.dispatch(updateCommonLoader(false));
    }, 100);
    return Promise.reject(error);
  }
)


export const logout = () => {
  try {
    store.dispatch(updateCommonLoader(true));
    axiosInstance.defaults.headers.common["Authorization"] = "";
    localStorage.clear();
    sessionStorage.clear();
    store.dispatch(resetState());
    history.push("/");
    window?.location?.reload(true);
    Toast({ type: "success", message: "Logged Out successfully " });
  } catch (error) {
    console.error("Logout failed:", error);
    Toast({ type: "error", message: "Failed to log out. Please try again." });
  } finally {
    store.dispatch(updateCommonLoader(false));
  }
};

// export const logout = async (profileId) => {
//   if (profileId) {
//     try {
//       store.dispatch(updateCommonLoader(true));
//       const response = await userLogout(profileId); 

//       if (response?.status === 200) {
//         axiosInstance.defaults.headers.common["Authorization"] = "";
//         localStorage.clear();
//         store.dispatch(resetState());
//         Toast({ type: "success", message: "Logged Out successfully" });

//         // Redirect to login page after successful logout
//         window.location.href = "/login";
//       }
//     } catch (error) {
//       Toast({ type: "error", message: "Failed to log out. Please try again." });
//     } finally {
//       store.dispatch(updateCommonLoader(false));
//     }
//   } else {
//     axiosInstance.defaults.headers.common["Authorization"] = "";
//     localStorage.clear();
//     store.dispatch(resetState());
//     window.location.href = "/login";
//   }
// };



